import axios from "axios";
import apiUrl from "../utility/apiUrl";

export const sendChatMessage = ({ message, history }) =>
  axios.post(
    `${apiUrl}/api/v1/chat/message`,
    { message, history },
    {
      headers: { "ngrok-skip-browser-warning": "any" },
      timeout: 60000,
    }
  );
